// Copyright (C) 2025 Sorama

import { autoinject } from "aurelia-dependency-injection";
import { bindable, customElement } from "aurelia-templating";

export interface ICurrentlyActivatedPackage {
    name: string;
    tier: string;
    expirationDate: Date | null;
    isLifetime: boolean;
    tag: string;
}

@customElement("package-badge")
@autoinject
export class PackageBadge {
    @bindable package: ICurrentlyActivatedPackage;
    @bindable hideValidity = false;

    get badgeClass(): string {
        if (!this.package?.tier) return "";

        const tierLower = this.package.tier.toLowerCase();
        return `${tierLower}-badge`;
    }

    get displayName(): string {
        const { tier, name } = this.package ?? {};
        if (!tier || !name) return "";
        return (tier === name ? tier : `${tier} - ${name}`).toUpperCase();
    }

    get showValidity(): boolean {
        return !this.hideValidity && !!this.package?.expirationDate && !this.package?.isLifetime;
    }

    constructor(private element: Element) {}
}
